// src/contexts/EchoContext.tsx
import Echo from 'laravel-echo';
import React, { createContext, useContext, useEffect, useLayoutEffect, useState } from 'react';
import { createEchoInstance } from 'src/hooks/echo';
import useAuth from 'src/hooks/useAuth';
import { User } from 'src/models/user';
import slice from 'src/slices/messenger';
import { useDispatch } from 'src/store';



interface EchoContextType {
  logins: User[];
  echoPusher: any;
  pusherState: any;
}

const EchoContext = createContext<EchoContextType>({
  logins: [],
  echoPusher: null,
  pusherState: null
});


export const EchoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [logins, setLogins] = useState<User[]>([]);
  const [echoPusher, setEchoPusher] = useState<Echo>();
  const [pusherState, setPusherState] = useState<any>(null);
  const { user } = useAuth()
  const dispatch = useDispatch();

  useLayoutEffect(() => {

    console.log("🔄 EchoProvider mounted");
    const echo = createEchoInstance(user?.token);




    setEchoPusher(echo)
    const channel = echo.private('logins').error((error) => {
      console.error('*^^^^^^^^^^^Subscription error:', error);
      if (error.status === 500) {
        console.warn('Not authorized to join channel.');
      }
    })

    echo.connector.pusher.connection.bind('state_change', (states) => {
      console.log('Echo connection state changed:', states);
      setPusherState(states)
      if (states.current === 'connected') {
        console.log('Echo is connected. You can resubscribe here.');
      }
    });

    console.log("++++++SOCKETID++++++", echo.connector
    );
    dispatch(slice.actions.setSessionId(echo.connector.pusher.sessionID));

    console.log("======CHAR======", channel)

    channel.listen('.user.logged.in', (event: { user: User }) => {
      // alert()
      console.log('📡+++++++++++++++++ New login received:', event.user);
      setLogins(prev => [...prev, event.user]);
    });

    return () => {
      echo.leave('logins');
    };

  }, [user]);

  return (
    <EchoContext.Provider value={{ logins, echoPusher, pusherState }}>
      {children}
    </EchoContext.Provider>
  );
};

export const useEcho = () => useContext(EchoContext);
